import * as React from 'react';
import shouldFlipBG from '../utils/should-flip-bg';

interface MultiActionOptionProps {
  id: string;
  name: string;
  label: string;
  theme?: 'night' | 'day';
  onClick?: Function;
  href?: string;
  description?: string;
  image?: string;
}

interface MultiActionOptionState {
  flipBg: string;
}

export default function MultiActionOption(props: MultiActionOptionProps) {
  const inputEl: any = React.useRef(null);
  const { theme = 'day' } = props;

  const [state, setState] = React.useState<MultiActionOptionState>({
    flipBg: ''
  });

  const handleMouseDown = () => {
    if (inputEl.current) {
      inputEl.current.classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (inputEl.current) {
      if (e.keyCode === 9) {
        inputEl.current.classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputEl, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
  }, []);

  return (
    <div className="multi-action-options">
      <a
        ref={inputEl}
        onClick={e => {
          if (props.onClick) {
            props.onClick();
            e.preventDefault();
          }
        }}
        href={props.href ? props.href : 'javasciprt:void(0)'}
        key={props.id}
        aria-label={props.label}
      >
        <div className={`multi-action-option ${state.flipBg}`}>
          {props.image && (
            <img
              alt={props.label}
              id={props.label}
              className="image"
              src={props.image}
            />
          )}
          <div>
            <div className="label">{props.label}</div>
            {props.description && (
              <div className="description">{props.description}</div>
            )}
          </div>
        </div>
      </a>
    </div>
  );
}
